
// export const myGetter = ( state ) => {
//  return state
// }

export const sitesList = state => state.sites
export const sitesSelectable = state => state.sitesSelectable
export const sitesPaginatedData = state => state.sitesPaginatedData
export const site = state => state.site
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData